module.exports = __webpack_public_path__ + "static/media/clickipo-logo-tagline.3b3c7a00.png";